import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";

const MarketSurveyParameterForm = (props) => {
  const frmRef = useRef({});
  const [headId, setHeadId] = useState();
  const [data, setData] = useState("");
  const [filterdData, setFilterdData] = useState("");
  const [controlType, setControlType] = useState("");
  const [marketSurveyHeads, setMarketSurveyHeads] = useState([]);
  const [newHeadName, setNewHeadName] = useState("");
  const [marketSurveyFieldName, setMarketSurveyFieldName] = useState("");
  const [itemList, setItemList] = useState([]);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: postMarketSurveyHeadName } = useHttp();

  const addMarketSurveyHead = (e) => {
    e.preventDefault();

    if (newHeadName.trim()) {
      const isDuplicate = marketSurveyHeads.some(
        (item) =>
          item.marketSurveyHeadName.toLowerCase() ===
          newHeadName.trim().toLowerCase()
      );

      if (isDuplicate) {
        toast.error("Name already present in list");
        setNewHeadName("");
      } else {
        const data = {
          marketSurveyHeadName: newHeadName.trim(),
          status: 1,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          serviceId: props.sId,
        };
        postMarketSurveyHeadName(
          {
            url: "/api/marketSurveyHeadList/",
            method: "POST",
            body: data,
          },
          (data) => {
            toast.success(`Market survey head name added successfully`);
            setHeadId(data.marketSurveyHeadId);
            setMarketSurveyHeads((prev) => [
              ...prev,
              {
                marketSurveyHeadId: data.marketSurveyHeadId,
                marketSurveyHeadName: newHeadName.trim(),
              },
            ]);
            setIsModalOpen(false);
            setNewHeadName("");
          }
        );
      }
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const openType = () => {
    setIsOpen(true);
  };

  const closeType = () => {
    setIsOpen(false);
  };

  const addItemToList = (e) => {
    e.preventDefault();

    const newItem = frmRef.current["itemName"]
      ? frmRef.current["itemName"].value
      : "";
    if (newItem && !itemList.includes(newItem)) {
      setItemList((prevItemList) => [...prevItemList, newItem]);

      frmRef.current["itemName"].value = "";
    } else {
      toast.error("Item already exists in the list");
    }

    closeModal();
  };

  const { sendRequest: postMarketSurveyHeadField } = useHttp();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      (controlType === "List" || controlType === "RadioButton") &&
      itemList.length === 0
    ) {
      toast.error(
        "Please add at least one parameter detail for the selected control type."
      );
    } else {
      const data = {
        marketSurveyFieldName: marketSurveyFieldName,
        marketSurveyHeadId: parseInt(headId),
        controlType: controlType,
        itemList: itemList,
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        serviceId: props.sId,
      };
      postMarketSurveyHeadField(
        {
          url: "/api/marketSurveyHeadFieldList/",
          method: "POST",
          body: data,
        },
        (data) => {
          toast.success(`Market survey details added successfully`);
          props.addForm(false);

          getAllData();
          setMarketSurveyFieldName("");
          setControlType("");
          setItemList([]);
        },
        (error) => {
          toast.error("Data is already present in the list");
        }
      );
    }
  };

  const { sendRequest: getData } = useHttp();

  const getAllData = () => {
    getData(
      {
        url: `/api/marketSurveyHeadFieldList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        setData(res);
        setFilterdData(res);
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const { sendRequest: getHeadName } = useHttp();

  const getHeadData = () => {
    getHeadName(
      {
        url: `/api/marketSurveyHeadList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        setMarketSurveyHeads(res);
      }
    );
  };

  useEffect(() => {
    getHeadData();
  }, []);

  const handleDelete = (index) => {
    const updatedItems = itemList.filter((_, i) => i !== index);
    setItemList(updatedItems);
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems =
    filterdData && filterdData.slice(offset, offset + itemsPerPage);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Market Survey Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Market Survey Head Name</label> &nbsp;
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-sm"
                          onClick={openModal}
                        >
                          +
                        </button>
                        <select
                          id={"marketSurvey"}
                          required
                          onChange={(e) => setHeadId(e.target.value)}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {marketSurveyHeads.map((item) => (
                            <option
                              key={item.marketSurveyHeadId}
                              value={item.marketSurveyHeadId}
                            >
                              {item.marketSurveyHeadName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Control Type</label>

                        <select
                          id={"controlType"}
                          required
                          className="form-control"
                          onChange={(e) => setControlType(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="TextBox">TextBox</option>
                          <option value="List">List</option>
                          <option value="RadioButton">Radio Button</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      {controlType === "List" ||
                      controlType === "RadioButton" ? (
                        <div
                          className="flexColumn"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            type="button"
                            className="btn  btn-primary mx-2 my-2"
                            onClick={openType}
                          >
                            Add Paramter Detail
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label>Market Survey Field Name</label>
                      <textarea
                        id={"marketSurveyFieldName"}
                        required
                        value={marketSurveyFieldName}
                        onChange={(e) =>
                          setMarketSurveyFieldName(e.target.value)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      <Modal
        isOpen={isModalOpen}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <div>
          <form onSubmit={addMarketSurveyHead} className="text-center">
            <h3 className="card-title">Add Market Survey Head Name </h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <div className="col-md-8">
                <label> Market Survey Head Name</label>
                <input
                  type={"input"}
                  value={newHeadName}
                  id="marketSurveyheadName"
                  required
                  onChange={(e) => setNewHeadName(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            <br />
            <div className="text-center">
              <button className="btn  btn-primary mx-2 my-2" type="submit">
                submit
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={isOpen}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <h3 className="card-title">Paramter Details</h3>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>

        <div>
          <form onSubmit={addItemToList}>
            <div className="row">
              <div className="form-group">
                <label>Paramter Name</label>
                <input
                  type="text"
                  id={"itemName"}
                  required
                  ref={(el) => (frmRef.current["itemName"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3"> </div>
              <div className="col-md-3">
                <button className="btn  btn-primary mx-2 my-2" type="submit">
                  Add
                </button>
              </div>
            </div>

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No</th>
                    <th>Item Name</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {itemList.map((items, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{items}</td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => handleDelete(index)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </form>
          <div></div>
        </div>
      </Modal>
    </>
  );
};

export default MarketSurveyParameterForm;
